var React = require('react');

function TeamViewer (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Union","fillRule":"evenodd","clipRule":"evenodd","d":"M7.92917 0.330078H44.071C48.2671 0.330078 51.6701 3.73307 51.6701 7.92917V44.071C51.6701 48.2671 48.2671 51.6701 44.071 51.6701H7.92917C3.73307 51.6701 0.330078 48.2671 0.330078 44.071V7.92917C0.330078 3.73307 3.73307 0.330078 7.92917 0.330078ZM5.36079 25.9955C5.36079 37.3941 14.6014 46.6348 26.0001 46.6348V46.6394C37.3987 46.6394 46.6394 37.3987 46.6394 26.0001C46.6394 14.6014 37.3987 5.36079 26.0001 5.36079C14.6014 5.36079 5.36079 14.5968 5.36079 25.9955ZM30.1594 18.7192L43.4762 25.9955L30.1594 33.2811L31.6257 28.6884H20.3746L21.8364 33.2811L8.51949 26.0001L21.8364 18.7192L20.3746 23.3072H31.6257L30.1594 18.7192Z","fill":"#E0E7F6"}));
}

TeamViewer.defaultProps = {"width":"52","height":"52","viewBox":"0 0 52 52","fill":"none"};

module.exports = TeamViewer;

TeamViewer.default = TeamViewer;
